import { render, staticRenderFns } from "./Product-data.vue?vue&type=template&id=060490b8"
import script from "./Product-data.vue?vue&type=script&lang=js"
export * from "./Product-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports